// extracted by mini-css-extract-plugin
export default {"root":"style_root__+c-2c","progerssBar":"style_progerssBar__NooOD"};